<div class="dialog-content-wrapper" cslPerfectScrollbar>
  <div mat-dialog-title>
    <span i18n class="title dialog-title">Настройка полей</span>
    <button mat-button class="mat-icon-button" (click)="dialogRef.close(undefined)" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div mat-dialog-content fusePerfectScrollbar class="mat-dialog-content p-0 pb-0 m-0">
    <div class="flex flex-col justify-start items-stretch">
      <mat-table #table [dataSource]="dataSource">
        <!-- Checkbox Column -->
        <ng-container matColumnDef="visible">
          <mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              (change)="$event ? masterToggle() : null"
              [checked]="selection.hasValue() && isAllSelected()"
              [indeterminate]="selection.hasValue() && !isAllSelected()">
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let row">
            <mat-checkbox
              (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row.name) : null"
              [checked]="selection.isSelected(row.name)">
            </mat-checkbox>
          </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <mat-header-cell i18n *matHeaderCellDef>Название</mat-header-cell>
          <mat-cell *matCellDef="let item; let rowIndex = index">
            <ng-container [ngSwitch]="item.name">
              <span *ngSwitchCase="'position'" i18n>Позиция</span>
              <span *ngSwitchCase="'name'" i18n>Наименование</span>
              <span *ngSwitchCase="'orientation'" i18n>Текстура задана</span>
              <span *ngSwitchCase="'attachment'" i18n>Вложение</span>
              <span *ngSwitchCase="'editedAngles'" i18n>Наличие углов с обработкой</span>
              <span *ngSwitchCase="'slotCount'" i18n>Количество пазов на панели</span>
              <span *ngSwitchCase="'fastenersExists'" i18n>Наличие присадки</span>
              <span *ngSwitchCase="'faceBandingExists'" i18n>Наличие облицовки пласти</span>
              <span *ngSwitchCase="'outlineEditor'" i18n>Редактор контура</span>
              <span *ngSwitchCase="'remark'" i18n>Примечание</span>
              <span *ngSwitchDefault></span>
            </ng-container>

            <!-- <mat-form-field class="w-full" appearance="outline">
                            <input type="text" class="w-full" matInput [(ngModel)]="item.displayName">
                        </mat-form-field> -->
          </mat-cell>
        </ng-container>

        <!-- Description Column -->
        <!-- <ng-container matColumnDef="description">
                    <mat-header-cell i18n *matHeaderCellDef>Описание</mat-header-cell>
                    <mat-cell *matCellDef="let item; let rowIndex = index">

                        <mat-form-field class="w-full" appearance="outline">
                            <input type="text" class="w-full" matInput [(ngModel)]="item.description">
                        </mat-form-field>
                    </mat-cell>
                </ng-container> -->

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns">
          <!--(click)="toggleVisible(row)">-->
        </mat-row>
      </mat-table>
    </div>
  </div>

  <div mat-dialog-actions class="m-0 p-4 flex flex-row justify-end items-center">
    <button i18n mat-raised-button class="mat-accent mr-4" (click)="saveOptionsAndClose()">ОК</button>
    <button i18n mat-button (click)="dialogRef.close(undefined)">ОТМЕНА</button>
  </div>
</div>
